import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { useState } from "react";

/**
 * Componente de filtro customizado que renderiza um `Dropdown` para colunas booleanas.
 * É projetado para ser usado na propriedade `filterElement` do componente `Column` do PrimeReact.
 *
 * @param {object} props - As propriedades do componente.
 * @param {ColumnFilterElementTemplateOptions} props.options - As opções de template fornecidas pelo `DataTable`,
 * que incluem o valor atual do filtro e a função `filterCallback`.
 */
const PermissionTypeDropdown: React.FC<{
  options: ColumnFilterElementTemplateOptions;
}> = ({ options }) => {
  /** Estado que armazena as opções do dropdown (Sim/Não). */
  const [permissionTypeOptions, setPermissionTypeOptions] = useState<
    { label: string; value: string }[]
  >([
    { label: "Sim", value: "true" },
    { label: "Não", value: "false" },
  ]);

  return (
    <Dropdown
      value={options.value}
      options={permissionTypeOptions}
      onChange={(e) => options.filterCallback(e.value)}
      placeholder="Selecione o status..."
      showClear
    />
  );
};
export default PermissionTypeDropdown;
